import { defineMessages } from 'react-intl';

export default defineMessages({
  FORBIDDEN: {
    id: 'app.utils.api.FORBIDDEN',
    defaultMessage: 'You do not have sufficient access rights',
  },
});
